export enum FamilyCustomActionEnum {
  enable = 'Abilita',
  disable = 'Disabilita',
}
